import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#CEEDFF"
      d="M11 11.5a8.5 8.5 0 1 1 8.5 8.5h-10a5.499 5.499 0 0 1-3.889-9.39 5.5 5.5 0 0 1 5.677-1.31"
    />
    <path
      fill="#80C4FF"
      fillRule="evenodd"
      d="M21.353 2.183a9.5 9.5 0 0 0-9.752 4.04l-.19.295a9.5 9.5 0 0 0-.775 1.565l-.007.015-.21-.035a6.496 6.496 0 0 0-5.516 1.84 6.5 6.5 0 0 0 .001 9.193A6.5 6.5 0 0 0 9.5 21h4.932l-2.93 4.45a1 1 0 1 0 1.671 1.1L16.827 21H19.5a9.5 9.5 0 0 0 8.777-5.865 9.5 9.5 0 0 0-2.06-10.353 9.5 9.5 0 0 0-4.864-2.6M16.303 19H19.5a7.5 7.5 0 0 0 6.929-4.63 7.5 7.5 0 0 0-1.626-8.174 7.497 7.497 0 0 0-11.538 1.137A7.5 7.5 0 0 0 12 11.5a1 1 0 1 1-2 0q0-.706.103-1.398l.01-.062-.019-.002a4 4 0 0 0-.296-.03L9.5 10a4.499 4.499 0 1 0 0 9h6.804"
      clipRule="evenodd"
    />
    <path
      fill="#80C4FF"
      d="M18.453 24.45a1 1 0 0 1 1.67 1.1l-3.287 5a1 1 0 1 1-1.671-1.1z"
    />
  </svg>
);
const SvgIconWeatherCloudRain = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloudRain);
export default Memo;
